import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { fieldRequired, requiredInput } from '../../../core/formValidation';

export const VendorFormFields = ({ name = 'vendors', control: controlProp, fields }) => {
  // If used with redux-form FieldArray, render legacy API
  if (fields) {
    return (
      <div className="inline-add-item-button">
        {fields.map((vendor, index) => (
          <div key={index} className="field-row">
            <div className="field-row-heading">
              <p>{`Vendor #${index + 1}`}</p>
              <button
                type="button"
                className={classNames('close', 'no-float', 'multi-form-delete')}
                onClick={() => fields.remove(index)}
              >
                <i className="icon icon-squared-cross" />
              </button>
            </div>
            <div className="form-group">
              <Field
                className="form-control row-padding"
                name={`${vendor}.name`}
                id="name"
                component={requiredInput}
                type="text"
                aria-describedby="descriptionHelp"
                placeholder="Name"
                validate={[fieldRequired]}
              />
            </div>
          </div>
        ))}
        <button
          type="button"
          className={classNames('button')}
          data-testid="addVendorButton"
          onClick={() => fields.push({ name: '' })}
        >
          Add Vendor
        </button>
      </div>
    );
  }

  // RHF path
  const ctx = useFormContext();
  const control = controlProp || (ctx && ctx.control);
  if (!control) {
    return null;
  }
  const { fields: rhfFields, append, remove } = useFieldArray({ name, control });

  return (
    <div className="inline-add-item-button">
      {rhfFields.map((field, index) => (
        <div key={field.id} className="field-row">
          <div className="field-row-heading">
            <p>{`Vendor #${index + 1}`}</p>
            <button
              type="button"
              className={classNames('close', 'no-float', 'multi-form-delete')}
              onClick={() => remove(index)}
            >
              <i className="icon icon-squared-cross" />
            </button>
          </div>
          <div className="form-group">
            <Controller
              name={`${name}.${index}.name`}
              control={control}
              rules={{ required: fieldRequired }}
              render={({ field: ctlField }) =>
                requiredInput({
                  input: ctlField,
                  id: 'name',
                  className: 'form-control row-padding',
                  type: 'text',
                  ariaDescribedBy: 'descriptionHelp',
                  placeholder: 'Name',
                })
              }
            />
          </div>
        </div>
      ))}
      <button
        type="button"
        className={classNames('button')}
        data-testid="addVendorButton"
        onClick={() => append({ name: '' })}
      >
        Add Vendor
      </button>
    </div>
  );
};

VendorFormFields.propTypes = {
  name: PropTypes.string,
  control: PropTypes.any,
  fields: PropTypes.shape({
    map: PropTypes.func,
    push: PropTypes.func,
    remove: PropTypes.func,
    update: PropTypes.func,
    get: PropTypes.func,
  }),
};

export default VendorFormFields;
